import { useQuery } from '@tanstack/react-query';
import { CanaryRolloutStatusResult } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useGetCanaryRolloutStatus = () =>
  useQuery({
    queryKey: queryKeys.canaryRolloutStatus.all(),
    queryFn: fetchCanaryRolloutStatus,
  });

async function fetchCanaryRolloutStatus(): Promise<CanaryRolloutStatusResult> {
  return requestCCApi({ url: '/canaryRolloutStatus' }, false);
}
